import React from 'react';
import PropTypes from 'prop-types';
import Heading from 'common-ui-components/dist/components/Atoms/Heading';
import './ShoppingCartTotalItems.scss';

const ShoppingCartTotalItems = props => {
  const {
    cartItemsNumber,
    headingLabel,
    itemsLabel,
    itemLabel,
    quoteNumberLabel,
    isQuoteToOrder,
    sessionQuoteId,
  } = props;
  const itemText = cartItemsNumber === 1 ? itemLabel : itemsLabel;
  const quoteToOrderClass = isQuoteToOrder ? 'quoteToOrder' : '';

  return (
    <div className="row shoppingCartItemsTotal" data-locator="shopping-cart-total-item-heading">
      <Heading elementLocator="heading-shopping-cart-total-item-label">{headingLabel}</Heading>
      {cartItemsNumber !== 0 && (
        <>
          <Heading
            HeadingType="h2"
            className={`shoppingCartItemsNumber ${quoteToOrderClass}`}
            elementLocator="shopping-cart-total-item-number"
          >
            {`(${cartItemsNumber} ${itemText})`}
          </Heading>
          {isQuoteToOrder && (
            <div className="shoppingCartQuote">
              <div
                className="shoppingCartQuoteNumber"
                data-locator="shopping-cart-total-quote-number"
              >
                {`${quoteNumberLabel}: ${sessionQuoteId}`}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

ShoppingCartTotalItems.propTypes = {
  headingLabel: PropTypes.string,
  itemsLabel: PropTypes.string,
  itemLabel: PropTypes.string,
  cartItemsNumber: PropTypes.number,
  isQuoteToOrder: PropTypes.bool,
  sessionQuoteId: PropTypes.string,
  quoteNumberLabel: PropTypes.string,
};

ShoppingCartTotalItems.defaultProps = {
  headingLabel: '',
  itemsLabel: '',
  itemLabel: '',
  cartItemsNumber: 0,
  isQuoteToOrder: false,
  sessionQuoteId: '',
  quoteNumberLabel: '',
};

export default ShoppingCartTotalItems;
